// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1PharmacyBiResultSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiResultSearchDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1PharmacyBiResultSearchDefaultResponseData.discriminator = undefined;
PharmacyV1PharmacyBiResultSearchDefaultResponseData.additionalProperties = false;
PharmacyV1PharmacyBiResultSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "results",
        "baseName": "results",
        "type": ""
    },
];
//# sourceMappingURL=pharmacyV1PharmacyBiResultSearchDefaultResponseData.js.map